import React from 'react';
import { StyledDragAndDrop } from '@components/upload/styled.tsx';
import type { UploadProps } from 'antd';

type BaseDragAndDropProps = UploadProps & {
    content: React.ReactNode;
};

export const BaseDragAndDrop: React.FC<BaseDragAndDropProps> = ({ content, ...props }) => (
    <StyledDragAndDrop {...props}>{content}</StyledDragAndDrop>
);
